<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="d_flex">
                <h1 class="campus_detailes">Campus Details</h1>
                <i class="fa fa-times closebtn" aria-hidden="true" [mat-dialog-close]="true"></i>
            </div>
           
            <div class="row col-md-12 ">
                <ul class="list-unstyled col-md-12">
                    <li class="d-flex  py-2">
                        <span class="fw-medium col-5">City</span>
                        <span class="course_name col-7">{{city}}</span>
                    </li>
                     <li class="d-flex  py-2">
                        <span class="fw-medium  col-5">Campus</span>
                        <span class="student_name col-7">{{campus}}</span>
                    </li>
                      <li class="d-flex  py-2">
                        <span class="fw-medium  col-5">Building</span>
                        <span class="student_name col-7">{{building}}</span>
                    </li>
                    
                    <li class="d-flex  py-2">
                        <span class="fw-medium  col-5">Block No</span>
                        <span class="student_name col-7">{{block}}</span>
                    </li>
                    <li class="d-flex  py-2">
                        <span class="fw-medium  col-5">Floor No</span>
                        <span class="student_name col-7">{{Floor}}</span>
                    </li>
                     <li class="d-flex  py-2">
                        <span class="fw-medium  col-5">Room No</span>
                        <span class="student_name col-7">{{Room}}</span>
                    </li>
                    <li class="d-flex  py-2">
                        <span class="fw-medium  col-5">Activity</span>
                        <span class="student_name col-7">{{Activity}}</span>
                    </li>
                   
                   
                </ul>
              
            </div>
            <div *ngIf="imagedatalist?.length > 0; else noImages"  class="">
                <div *ngFor="let img of imagedatalist" class="image-card">
                    <img [src]="img.url" alt="Hygiene Image" width="200">
                    <!-- <p>Uploaded: {{ img.uplodedTime }}</p> -->
                </div>
            </div>

            <ng-template #noImages>
                <p>No images available</p>
            </ng-template>
        </div>
    </div>
</div>